import React from 'react';
import { useTranslation } from 'react-i18next';
import rem from '../../utils/rem';
import { Box, Flex, Text } from '../primitives';

type Props = {
  selectedValue: number;
  onClick: (value: number) => void;
  isMobile?: boolean;
};

const ImportanceLevel = ({
  selectedValue,
  onClick,
  isMobile = false,
}: Props) => {
  const { t } = useTranslation();

  const handleClickLevel = (index: number) => () => {
    onClick(index);
  };

  const renderLevel = (level: string, index: number) => {
    const isPreselected = index === selectedValue;

    return (
      <Flex
        flexDirection="column"
        width={rem(106)}
        textAlign="center"
        alignItems="center"
        flexGrow={0}
        onClick={handleClickLevel(index)}
        cursor="pointer"
        justifyContent="flex-end"
      >
        <Text
          fontSize="size16"
          fontStyle="italic"
          mb="small"
          color={isPreselected ? 'accent' : 'secondary'}
        >
          {level}
        </Text>
        <Box>
          <Box
            zIndex={1}
            cursor="pointer"
            size={rem(16)}
            borderRadius="50%"
            backgroundColor={isPreselected ? 'accent' : 'gallery'}
          />
          {index < 3 && (
            <Box
              position="absolute"
              left={rem(16)}
              top={rem(6)}
              height={rem(4)}
              width={rem(100)}
              backgroundColor="gallery"
            />
          )}
        </Box>
      </Flex>
    );
  };

  return (
    <Flex flexWrap="wrap">
      <Text fontSize={isMobile ? rem(14) : 'body'} mr="xLarge" mb="small">
        {t('importanceLevels.title')}
      </Text>
      <Flex flex="0 1 auto">
        {/* we do NOT want grow on it (shrink is fine), as the bullet must stay close to each other even on large screen */}
        <Flex>{renderLevel(t('importanceLevels.levels.notImportant'), 1)}</Flex>
        <Flex>{renderLevel(t('importanceLevels.levels.important'), 2)}</Flex>
        <Flex>{renderLevel(t('importanceLevels.levels.mandatory'), 3)}</Flex>
      </Flex>
    </Flex>
  );
};

export default ImportanceLevel;
